import axios from "axios";
import interceptors from "@/shared/api/interceptors";

// Notary Calls service (queue-types, requests, etc).
// Full paths under this client resolve as `<baseURL>/<path>`, e.g.
//   GET  /queue-types  -> https://notary.q19.kz/cc/v1/calls/queue-types
//   POST /requests     -> https://notary.q19.kz/cc/v1/calls/requests
// X-API-Key is NOT added here in code — it's injected by interceptors.
const apiClientCalls = axios.create({
  baseURL: (window.__CONFIG__?.VUE_APP_BASE_DOMAIN || "") + "/cc/v1/calls",
  withCredentials: true,
});

interceptors(apiClientCalls);
export default apiClientCalls;
